import { useEffect, useMemo, useState } from "react";
import { Controller, useFieldArray } from "react-hook-form";
import Select from "react-select";
import { EmailTemplateService } from "../../services/emailTemplateService";

export default function EmailPartial({
  control,
  errors,
  register,
  getValues,
  setValue,
  watch,
  contentRepositories,
}) {
  const [templates, setTemplates] = useState([]);

  const include_content_repository = watch("include_content_repository");
  const templateSelected = watch("email.template");

  const systemVars = [
    {
      label: "contact.full_name",
      value: "contact.full_name",
    },
    {
      label: "contact.first_name",
      value: "contact.first_name",
    },
    {
      label: "contact.last_name",
      value: "contact.last_name",
    },
    {
      label: "contact.email",
      value: "contact.email",
    },
    {
      label: "contact.phone_number",
      value: "contact.phone_number",
    },
    {
      label: "contact.type",
      value: "contact.type",
    },
    {
      label: "contact.medical_specialty",
      value: "contact.medical_specialty",
    },
  ];

  const varsSource: any = [
    {
        value: 'system',
        label: 'Sistema',
    },
    {
        value: 'const',
        label: 'Constante',
    },
    // {
    //     value: 'content_repository',
    //     label: 'Material',
    // },
    // {
    //     value: 'custom',
    //     label: 'Dinámico',
    // },
]

  const { fields, append, remove } = useFieldArray({
    control,
    name: "email.tokens",
  });


  const getTemplates = async () => {
    const response = await EmailTemplateService.getAll();
    setTemplates(response.map((a: any) => ({ value: a._id, label: `${a.name}`, html: a.html })));
  };

  useEffect(() => {
    const html = templates.find((t: any) => t.value === templateSelected)?.html ?? '';

    const regex = /\{\{([^}]+)\}\}/g;
    const vars = html.match(regex);

    if(vars && vars.length > 0) {
      const filteredVars = vars.filter((item, index) => vars.indexOf(item) === index);
      const tokens = filteredVars.map( t => ({ 
        token: t, 
        source: '', 
        const: '',
        custom: '',
        system: '',
      }));
      append(tokens, { shouldFocus: false });
    } else {
      remove();
    }

  }, [templateSelected]);

  useEffect(() => {
    getTemplates();
  }, []);

  return (
    <div className="row mt-5">
      <div className="col-3">
        <p className="text-dark fw-bold text-uppercase mb-3">
          Detalle plantilla
        </p>
        <p>Personaliza el contenido de la plantilla.</p>
      </div>
      <div className="col-9">
        <div className="card">
          <div className="card-body">
            <div className="row">
              <div className="col-12">
                <div className="m-b-24">
                  <div className="form-check form-switch ">
                    <label
                      className="form-check-label"
                      htmlFor="include_content_repository"
                    >
                      Vincular material
                    </label>
                    <input
                      type="checkbox"
                      className="form-check-input form-check-info"
                      id="include_content_repository"
                      {...register("include_content_repository")}
                    />
                  </div>
                </div>

                {include_content_repository && (
                  <div className="m-b-24">
                    {!watch("segmentations").length && (
                      <div className="alert alert-blue">
                        Para elegir un material, agrega uno o más segmentos para
                        buscar los materiales asociados a dichos segmentos.
                      </div>
                    )}

                    <label className="form-label">Material *</label>
                    <Controller
                      control={control}
                      name="content_repository"
                      rules={{ required: false }}
                      render={({
                        field: { onChange, onBlur, value },
                        fieldState: { error },
                      }) => (
                        <Select
                          placeholder="Seleccionar un material"
                          options={contentRepositories}
                          className={
                            error ? "form-select-custom is-invalid" : ""
                          }
                          classNamePrefix="form-select-custom"
                          onBlur={onBlur}
                          onChange={(value: any) => onChange(value.value)}
                          value={contentRepositories.filter(
                            (c) => c.value === value
                          )}
                        />
                      )}
                    />
                    <span className="invalid-feedback">Campo requerido.</span>
                  </div>
                )}

                <div className="m-b-24">
                  <label className="form-label">PLANTILLA DE MENSAJE*</label>
                  <Controller
                    control={control}
                    name="email.template"
                    rules={{ required: true }}
                    render={({
                      field: { onChange, onBlur, value },
                      fieldState: { error },
                    }) => (
                      <Select
                        placeholder="Selecciona una plantilla"
                        options={templates}
                        className={error ? "form-select-custom is-invalid" : ""}
                        classNamePrefix="form-select-custom"
                        onBlur={onBlur}
                        onChange={(value: any) => onChange(value.value)}
                        value={templates.filter((c) => c.value === value)}
                      />
                    )}
                  />
                  <span className="invalid-feedback">Campo requerido.</span>
                </div>

                {fields.map((field: any, index) => (
                  <div className="row" key={field.id}>
                    <div className="col-12">
                      <p className="text-dark fw-semibold mb-3">
                        {field.token}
                      </p>
                    </div>

                    <div className="col-6">
                      <div className="m-b-24">
                        <label className="form-label">Origen *</label>
                        <Controller
                          control={control}
                          name={`email.tokens.${index}.source`}
                          rules={{ required: true }}
                          render={({
                            field: { onChange, onBlur, value },
                            fieldState: { error },
                          }) => (
                            <Select
                              placeholder="Origen"
                              options={varsSource}
                              className={
                                error ? "form-select-custom is-invalid" : ""
                              }
                              classNamePrefix="form-select-custom"
                              onBlur={onBlur}
                              onChange={(value: any) => onChange(value.value)}
                              value={
                                varsSource.find((v) => v.value === value) || ""
                              }
                            />
                          )}
                        />
                        <span className="invalid-feedback">
                          Campo requerido.
                        </span>
                      </div>
                    </div>
                    <div className="col-6">
                      <div className="m-b-24">
                        <label className="form-label">Valor *</label>

                        {(!watch(`email.tokens.${index}.source`) ||
                          watch(`email.tokens.${index}.source`) ===
                            "const") && (
                          <input
                            className={
                              "form-control form-control-lg " +
                              (errors.email?.tokens?.[index]?.["const"]
                                ? "is-invalid"
                                : "")
                            }
                            {...register(`email.tokens.${index}.const`, {
                              required: true,
                              disabled:
                                watch(`email.tokens.${index}.source`) !==
                                "const",
                            })}
                          />
                        )}

                        {watch(`email.tokens.${index}.source`) === "system" && (
                          <>
                            <Controller
                              control={control}
                              name={`email.tokens.${index}.system`}
                              rules={{ required: true }}
                              render={({
                                field: { onChange, onBlur, value },
                                fieldState: { error },
                              }) => (
                                <Select
                                  placeholder="Variable"
                                  options={systemVars}
                                  className={
                                    error ? "form-select-custom is-invalid" : ""
                                  }
                                  classNamePrefix="form-select-custom"
                                  onBlur={onBlur}
                                  onChange={(value: any) =>
                                    onChange(value.value)
                                  }
                                  value={
                                    systemVars.find((v) => v.value === value) ||
                                    ""
                                  }
                                />
                              )}
                            />
                          </>
                        )}

                        <span className="invalid-feedback">
                          Campo requerido.
                        </span>
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              {templateSelected && (
                <div className="col-12">
                  <div>
                    <p className="text-dark fw-semibold text-uppercase font-12 mb-3">
                      Previsualización
                    </p>
                    <div
                      className="row"
                      style={{ height: "500px", overflow: "scroll" }}
                    >
                      <div
                        dangerouslySetInnerHTML={{
                          __html:
                            templates.find(
                              (t: any) => t.value === templateSelected
                            )?.html ?? "",
                        }}
                      />
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
